import { useCallback, useState } from 'react';

/**
 * Which connections of the Live Agent Platforms table have their full solution
 * list open. Not remembered: it starts empty with the page and is emptied again
 * whenever `env` changes.
 */
export const useExpandedConnections = (
  env: string
): {
  expanded: Record<string, boolean>;
  toggle: (connectionId: string) => void;
} => {
  const [expanded, setExpanded] = useState<Record<string, boolean>>({});
  const [prevEnv, setPrevEnv] = useState(env);

  // Reset while rendering, not in an effect: React re-runs this render at once
  // on a state update made here, so no frame is painted with the other env's
  // state. An effect would reset after that first frame. Keying the state by
  // connection id does not help either: coming back to the previous env
  // (A -> B -> A) would match the old entries again.
  if (prevEnv !== env) {
    setPrevEnv(env);
    setExpanded({});
  }

  // Stable identity: the page puts it in the dependencies of its memoized
  // `columns`.
  const toggle = useCallback(
    (connectionId: string) =>
      setExpanded((prev) => ({ ...prev, [connectionId]: !prev[connectionId] })),
    []
  );

  return { expanded, toggle };
};
